// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"2ba8908c","542":"a2c8345e"}[chunkId] + ".chunk.js";
};